import { LOADING, LOADING_FALSE } from "./types";

const reducer = (state, { type, payload }) => {
  switch (type) {
    case LOADING:
      return {
        ...state,
        loading: true,
      };
    case LOADING_FALSE:
      return {
        ...state,
        loading: false,
      };
    default:
      return {
        ...state,
        loading: false,
        data: payload,
      };
  }
};

export default reducer;
